import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import Text from './shared/components/Text'
import Banner from './shared/components/Banner'
import Snackbar from './shared/components/Snackbar'
import { SnackbarContainer } from './shared/components/Snackbar'
import Brand from './shared/components/Brand'
import SpinBox from './shared/components/Spinbox'
import Breadcrumb from './shared/components/Breadcrumb'
import BrandGroup from './shared/components/BrandGroup'
import Subtitle from './shared/components/Subtitle'
import Heading from './shared/components/Heading'
import Accordion from './shared/components/Accordion'
import Divider from './shared/components/Divider'
import Swiper from './shared/components/Swiper'
import Button from './shared/components/Button'
import Modal from './shared/components/Modal'
import Container from './shared/components/Container'
import Col from './shared/components/Col'
import Row from './shared/components/Row'
import Card from './shared/components/Card'
import Link from './shared/components/Link'
import LinkList from './shared/components/LinkList'
import Footer from './shared/components/Footer'
import Topic from './shared/components/Topic'
import TopicDetails from './shared/components/TopicDetails'
import LinkDetails from './shared/components/LinkDetails'
import ProgressBar from './shared/components/ProgressBar'
import Shortcut from './shared/components/Shortcut'
import Alert from './shared/components/Alert'
import Input from './shared/components/Input'
import RatingStars from './shared/components/RatingStars'
import Radio from './shared/components/Radio'
import IconGroup from './shared/components/IconGroup'
import HelpPassword from './shared/components/HelpPassword'
import Header from './shared/components/Header'
import CopyContainer from './shared/components/CopyContainer'
import Collapse from './shared/components/Collapse'
import Price from './shared/components/Price'
import Checkbox from './shared/components/Checkbox'
import Multimedia from './shared/components/Multimedia'
import Slider from './shared/components/Slider'
import Avatar from './shared/components/Avatar'
import Tag from './shared/components/Tag'
import Tooltip from './shared/components/Tooltip'
import Toggle from './shared/components/Toggle'
import Steps from './shared/components/Steps'
import Image from './shared/components/Image'
import TabSelect from './shared/components/TabSelect'
import Spinner from './shared/components/Spinner'
import Menu from './claro/components/Menu'
import Pagination from './shared/components/Pagination'
import SkipLink, {SkipLinkItem } from './shared/components/SkipLink'

import Calendar from './shared/components/Calendar'
import Countdown from './shared/components/Countdown'


// import Menu from './shared/components/Menu'

//hooks
import useLocalStorage from './hooks/useLocalStorage'
import useTheme, { setTheme } from './hooks/useTheme'
import useCopyToClipboard from './hooks/useCopyToClipboard'
import useFetch from './hooks/useFetch'
import useTab from './hooks/useTab'
import useMeasure from './hooks/useMeasure'

//Measure Lib
useMeasure();

export {
  // Core
  React,
  ReactDOM,
  // Component
  Alert,
  Avatar,
  SpinBox,
  Brand,
  BrandGroup,
  Breadcrumb,
  Banner,
  Text,
  Card,
  Checkbox,
  Link,
  LinkList,
  LinkDetails,
  Button,
  CopyContainer,
  Collapse,
  Row,
  Header,
  Container,
  Col,
  Input,
  Radio,
  Subtitle,
  Footer,
  Accordion,
  Heading,
  Divider,
  Swiper,
  Price,
  Topic,
  ProgressBar,
  TopicDetails,
  Shortcut,
  HelpPassword,
  IconGroup,
  RatingStars,
  Modal,
  Steps,
  Tooltip,
  Multimedia,
  Toggle,
  Tag,
  Slider,
  Image,
  TabSelect,
  Spinner,
  Calendar,
  Countdown,
  Menu,
  Pagination,
  Snackbar,
  SnackbarContainer,
  SkipLink,
  SkipLinkItem,
  // fim MenuBottom components

  //hooks
  useTheme,
  setTheme,
  useFetch,
  useTab,
  useCopyToClipboard,
  useLocalStorage,
  useMeasure
}
